module.exports = __webpack_public_path__ + "img/32.d0a40796.jpg";